/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeliveryCalculationMemberGradeRespVo
 */
export interface DeliveryCalculationMemberGradeRespVo {
    /**
     * 会员等级ID
     * @type {number}
     * @memberof DeliveryCalculationMemberGradeRespVo
     */
    id?: number;
    /**
     * 会员等级名称
     * 会员等级名称，已按当前语言处理
     * @type {string}
     * @memberof DeliveryCalculationMemberGradeRespVo
     */
    name?: string;
}

/**
 * Check if a given object implements the DeliveryCalculationMemberGradeRespVo interface.
 */
export function instanceOfDeliveryCalculationMemberGradeRespVo(value: object): value is DeliveryCalculationMemberGradeRespVo {
    return true;
}

export function DeliveryCalculationMemberGradeRespVoFromJSON(json: any): DeliveryCalculationMemberGradeRespVo {
    return DeliveryCalculationMemberGradeRespVoFromJSONTyped(json, false);
}

export function DeliveryCalculationMemberGradeRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliveryCalculationMemberGradeRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function DeliveryCalculationMemberGradeRespVoToJSON(json: any): DeliveryCalculationMemberGradeRespVo {
    return DeliveryCalculationMemberGradeRespVoToJSONTyped(json, false);
}

export function DeliveryCalculationMemberGradeRespVoToJSONTyped(value?: DeliveryCalculationMemberGradeRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

